module.exports = __webpack_public_path__ + "static/media/DSCF2431.cbe50a71.jpg";